(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hos-backup-bf-31oct"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hos-bf-carousel')) {
  customElements.define('hos-bf-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hos-bf__track');
      if (!this.track || this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.querySelector('[data-prev]').addEventListener('click', () => { this.paused = true; this.sync(); this.move(-1); });
      this.querySelector('[data-next]').addEventListener('click', () => { this.paused = true; this.sync(); this.move(1); });
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.track.addEventListener('pointerdown', () => { this.paused = true; this.sync(); });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault(); this.paused = true; this.sync(); this.move(e.key === 'ArrowLeft' ? -1 : 1);
      });
      this.motionHandler = () => { if (this.motion.matches) { this.paused = true; this.sync(); } };
      this.motion.addEventListener('change', this.motionHandler);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 5000);
      this.sync();
    }
    sync() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    move(direction) {
      const card = this.track.querySelector('li');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0);
      const end = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + step * direction;
      if (left > end + 2) left = 0;
      if (left < -2) left = end;
      this.track.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionHandler);
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hos-black-friday-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hos-bf-carousel')) {
  customElements.define('hos-bf-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hos-bf__track');
      if (!this.track || this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.querySelector('[data-prev]').addEventListener('click', () => { this.paused = true; this.sync(); this.move(-1); });
      this.querySelector('[data-next]').addEventListener('click', () => { this.paused = true; this.sync(); this.move(1); });
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.track.addEventListener('pointerdown', () => { this.paused = true; this.sync(); });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault(); this.paused = true; this.sync(); this.move(e.key === 'ArrowLeft' ? -1 : 1);
      });
      this.motionHandler = () => { if (this.motion.matches) { this.paused = true; this.sync(); } };
      this.motion.addEventListener('change', this.motionHandler);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 5000);
      this.sync();
    }
    sync() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    move(direction) {
      const card = this.track.querySelector('li');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0);
      const end = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + step * direction;
      if (left > end + 2) left = 0;
      if (left < -2) left = end;
      this.track.scrollTo({ left, behavior: this.motion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionHandler);
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hos-edit-vote"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.hseVoteInit) return;
  const params = new URLSearchParams(window.location.search);
  const posted = params.get('contact_posted') === 'true';
  let target = '';
  try { target = decodeURIComponent(window.location.hash.slice(1)); } catch (e) {}
  let stored = null;
  try { stored = window.sessionStorage.getItem('hseVoteLast'); } catch (e) {}

  const setMsg = (form, key, text) => {
    const el = form.querySelector('[data-hse-vote-msg="' + key + '"]');
    if (el) el.textContent = text;
  };

  const setup = (form) => {
    if (form.dataset.hseReady) return;
    form.dataset.hseReady = 'true';
    const isTarget = form.id && (form.id === target || (!document.getElementById(target) && form.id === stored));
    const ok = form.querySelector('[data-hse-vote-success]');
    const err = form.querySelector('[data-hse-vote-errors]');
    if (ok) {
      if (isTarget && posted) {
        ok.hidden = false;
        const fields = form.querySelector('.hse-vote__fields');
        if (fields) fields.hidden = true;
        ok.focus({ preventScroll: true });
        try { window.sessionStorage.removeItem('hseVoteLast'); } catch (e) {}
      } else {
        ok.remove();
      }
    }
    if (err) {
      if (isTarget) { err.hidden = false; err.focus({ preventScroll: true }); } else { err.remove(); }
    }

    const body = form.querySelector('[data-hse-vote-body]');
    const base = body ? body.value : '';
    const email = form.querySelector('input[type=email]');
    form.addEventListener('change', (event) => {
      if (event.target.name === 'contact[Vote]') {
        if (body) body.value = base + ' | Answer: ' + event.target.value;
        setMsg(form, 'vote', '');
      }
    });
    if (email) {
      email.addEventListener('input', () => {
        if (email.validity.valid) { email.removeAttribute('aria-invalid'); setMsg(form, 'email', ''); }
      });
    }
    form.addEventListener('invalid', (event) => {
      const field = event.target;
      if (field.name === 'contact[Vote]') setMsg(form, 'vote', 'Please choose Yes or No.');
      if (field === email) {
        email.setAttribute('aria-invalid', 'true');
        setMsg(form, 'email', email.validity.valueMissing ? 'Please enter your email address.' : 'Please enter a valid email address, like name@example.com.');
      }
    }, true);
    form.addEventListener('submit', () => {
      const checked = form.querySelector('input[name="contact[Vote]"]:checked');
      if (body && checked) body.value = base + ' | Answer: ' + checked.value;
      try { window.sessionStorage.setItem('hseVoteLast', form.id); } catch (e) {}
    });
  };

  const run = () => document.querySelectorAll('form[data-hse-vote-form]').forEach(setup);
  window.hseVoteInit = run;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sploots-category-details"] && !Shopify.designMode) return;
  try {
    function revealSplootsCategory() {
    let categoryId;
    try { categoryId = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
    const category = document.getElementById(categoryId);
    if (category?.matches('details.sploots-range-item')) category.open = true;
  }
  window.addEventListener('hashchange', revealSplootsCategory);
  document.addEventListener('shopify:section:load', revealSplootsCategory);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealSplootsCategory, { once: true });
  } else {
    revealSplootsCategory();
  }
  } catch(e) { console.error(e); }
})();

})();
